import React from "react";
import { Link } from "react-router-dom";
import HelpSectionHeader from "./HelpSectionHeader";
import { supportTopics } from "./helpPage.data";
import "./HelpTopicsSection.scss";

const HelpTopicsSection = () => (
  <section className="help-section">
    <HelpSectionHeader
      title="Popular topics"
      text="Fast paths for the most common customer questions."
    />

    <div className="help-topic-grid">
      {supportTopics.map((topic) => (
        <article className="help-topic" key={topic.title}>
          <h3>{topic.title}</h3>
          <p>{topic.text}</p>
          {topic.to ? (
            <Link to={topic.to}>{topic.linkLabel}</Link>
          ) : (
            <a href={topic.href}>{topic.linkLabel}</a>
          )}
        </article>
      ))}
    </div>
  </section>
);

export default HelpTopicsSection;
